// Every effect off, slow at 1, pitch/fast preferences off — same target as
// Reset in the footer.
export function areControlsAtDefaults({
  slowControl = 1,
  reverbAmount = 0,
  lowPassMode = false,
  highPassMode = false,
  lofiTapeMode = false,
  rainyMode = false,
  coffeeShopMode = false,
  hotelLoungeMode = false,
  cocktailBarMode = false,
  bitcrusherMode = false,
  vinylCrackleMode = false,
  bassBoostMode = false,
  phaserMode = false,
  echoMode = false,
  preservePitchMode = false,
  speedUpMode = false,
  videoFx = null,
} = {}) {
  return (
    (slowControl ?? 1) === 1 &&
    !(reverbAmount > 0) &&
    !lowPassMode &&
    !highPassMode &&
    !lofiTapeMode &&
    !rainyMode &&
    !coffeeShopMode &&
    !hotelLoungeMode &&
    !cocktailBarMode &&
    !bitcrusherMode &&
    !vinylCrackleMode &&
    !bassBoostMode &&
    !phaserMode &&
    !echoMode &&
    !preservePitchMode &&
    !speedUpMode &&
    !videoFx
  );
}
